import { Route, Routes, useNavigate } from "react-router";
import { Suspense, lazy, useEffect } from "react";
import { postRenderSetup } from "@mobile/init";
import { AuthLayout } from "@mobile/layouts/auth-layout";
import { AppLayout } from "@mobile/layouts/app-layout";
import { ProtectedRoute } from "@mobile/routes/protected-route";
import { Loading } from "@mobile/components/ui/loading";
import { useLastVisitedPath } from "@mobile/hooks/use-last-visited-path";

const LoginPage = lazy(() =>
  import("@mobile/pages/login").then((m) => ({ default: m.LoginPage })),
);
const WelcomePage = lazy(() =>
  import("@mobile/pages/welcome").then((m) => ({ default: m.WelcomePage })),
);
const ProfilePage = lazy(() =>
  import("@mobile/pages/profile").then((m) => ({ default: m.ProfilePage })),
);
const MemoListPage = lazy(() =>
  import("@mobile/pages/memo-list").then((m) => ({ default: m.MemoListPage })),
);
const MemoNewPage = lazy(() =>
  import("@mobile/pages/memo-new").then((m) => ({ default: m.MemoNewPage })),
);
const MemoDetailPage = lazy(() =>
  import("@mobile/pages/memo-detail").then((m) => ({
    default: m.MemoDetailPage,
  })),
);
const CalculatorsHomePage = lazy(() =>
  import("@mobile/pages/calculators-home").then((m) => ({
    default: m.CalculatorsHomePage,
  })),
);
const CompoundCalculatorPage = lazy(() =>
  import("@mobile/pages/compound-calculator").then((m) => ({
    default: m.CompoundCalculatorPage,
  })),
);
const MorePage = lazy(() =>
  import("@mobile/pages/more").then((m) => ({ default: m.MorePage })),
);
const NotFoundPage = lazy(() =>
  import("@mobile/pages/not-found").then((m) => ({ default: m.NotFoundPage })),
);

export function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    const cleanup = postRenderSetup({ navigate });
    return cleanup;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useLastVisitedPath();

  return (
    <Suspense fallback={<Loading className="fixed inset-0" />}>
      <Routes>
        {/* Auth Layout (로그인 전) */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>

        {/* Auth Layout + Protected (프로필 설정) */}
        <Route element={<AuthLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="/welcome" element={<WelcomePage />} />
          </Route>
        </Route>

        {/* App Layout - 계산기 + 더보기 (인증 불필요) */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<CalculatorsHomePage />} />
          <Route
            path="/calculators/compound"
            element={<CompoundCalculatorPage />}
          />
          <Route path="/more" element={<MorePage />} />
        </Route>

        {/* App Layout + Protected */}
        <Route element={<AppLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="/memos" element={<MemoListPage />} />
            <Route path="/memos/new" element={<MemoNewPage />} />
            <Route path="/memos/:id" element={<MemoDetailPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
